




























































import { Component, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import SupportTicketInjectorMixin from "@/mixins/supportTicketInjectorMixin";

// Types
import { IUser } from "@/models/users";

@Component({
  components: {
    "user-search-table": () =>
      import("@/components/app/global/user/userSearchTable.vue")
  }
})
export default class TicketAssignUsersDropdownList extends Mixins(
  SupportTicketInjectorMixin
) {
  // Variables

  public isProcessing = false;
  public isOpen = false;
  public queryText = "";

  // Methods

  public onActiveChange(isActive) {
    this.isOpen = isActive;
    if (!this.isOpen) this.queryText = "";
  }

  public async assignUser(user: IUser) {
    if (_.isEmpty(user) || this.isProcessing) return;
    try {
      this.isProcessing = true;
      await this.$ticketMethods.assignUsers(
        this.$_.map(
          this.$_.unionBy(this.ticketData.ticket.users, [user], "id"),
          ticketUser => ({
            id: ticketUser.id,
            default: user.id === ticketUser.id ? true : false
          })
        )
      );
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  // Computed

  public get leadAgentId(): IUser["id"] | null {
    return this.ticketData.leadAgent?.id || null;
  }

  public get userSearchProps() {
    return {
      excludeInactive: true,
      excludedIds: [this.leadAgentId],
      isCompact: true,
      isHoverable: false,
      limit: 20,
      skeletonCount: 3,
      manualFilters: {
        ["filter[api_user|eq]"]: false // Omit API users
      },
      rowTag: "a",
      rowProps: () => ({}),
      rowEvents: user => ({
        click: () => this.assignUser(user)
      })
    };
  }
}
